export default {
  icon: 'mdi-paperclip',
  name: 'Pièce jointes',
  loading: 'Chargement des documents ...',
  noItems: "Aucun document n'a été retrouvé.",
  customerPlatform: 'Espace Client',
  documentsFound: '{n} Document trouvé | {n} Documents trouvés',
};
